<app-navbar-panel></app-navbar-panel>
<app-sidebar (selectedItem)="mostrarItemSelecionado($event)" (menuStatus)="setStatusMenu($event)"></app-sidebar>
<div class="section-div" [ngClass]="{'section-div-active': menuOpen , 'section-div': !menuOpen}">
  <section>
    <router-outlet></router-outlet>
  </section>
</div>